/**
 * order_ref / cOID: nctminvst<ts><idNectum>-<isooper>:<A|B>[-SL / -TP]
 * El prefijo no lleva '-', así que el primer guion es el separador y el isooper puede
 * contener guiones (símbolos de broker como MKR-USD).
 */
export function isooperDeOrderRef(ref: string | null | undefined): string {
  const antesDeSentido = String(ref ?? '').split(':')[0];
  const guion = antesDeSentido.indexOf('-');
  return guion >= 0 ? antesDeSentido.substring(guion + 1) : '';
}

/** Sentido del order_ref ('A' / 'B'), sin el sufijo -SL / -TP. */
export function sentidoDeOrderRef(ref: string | null | undefined): string {
  return (String(ref ?? '').split(':')[1] ?? '').split('-')[0];
}

/** Las entradas siempre son MKT: toda STP/LMT es el SL/TP (OCO) de una posición abierta. */
const TIPOS_OCO = ['STP', 'STOP', 'LMT', 'LIMIT'];
const TIPOS_LIMIT = ['LMT', 'LIMIT'];
const TIPOS_ORDEN: Record<string, string> = { LMT: 'limit', LIMIT: 'limit', STP: 'stop', STOP: 'stop', MKT: 'market', MARKET: 'market' };

/** Tipo de orden normalizado: IBKR en vivo trae origOrderType; listaordenes, orderType. */
function tipoDeOrden(o: any): string {
  return String(o?.origOrderType ?? o?.orderType ?? '').toUpperCase();
}

export function esOrdenOco(o: any): boolean {
  return TIPOS_OCO.includes(tipoDeOrden(o));
}

/** STP = SL, LMT = TP (el sufijo -TP del order_ref/cOID manda si existe). */
export function ladoOco(o: any): 'sl' | 'tp' {
  const ref = String(o?.order_ref || o?.cOID || '');
  return ref.endsWith('-TP') || TIPOS_LIMIT.includes(tipoDeOrden(o)) ? 'tp' : 'sl';
}

/** Lado y tipo al estilo MetaTrader: 'buy limit', 'sell stop'… */
export function tipoOrdenMt(o: any): string {
  const tipo = String(o?.orderType ?? o?.origOrderType ?? '').toUpperCase();
  return [String(o?.side ?? '').toLowerCase(), TIPOS_ORDEN[tipo] ?? tipo.toLowerCase()].filter(t => t).join(' ');
}
